import RecordList from "../components/RecordList";
function ChallansPage() { return <RecordList title="Challans" endpoint="/challans" columns={[["challanNumber", "Challan no."], ["date", "Date"], ["vehicleNo", "Vehicle"], ["driverName", "Driver"], ["violationType", "Violation"], ["amount", "Amount"], ["paymentStatus", "Payment status"]]} />; }
export default ChallansPage;
